export * from './base.model';
export * from './country.model';
export * from './district.model';
export * from './general.model';
export * from './province.model';
export * from './response.model';
export * from './ward.model';
export * from './role.model';
export * from './department.model';
export * from './hub.model';
export * from './user.model';
export * from './hubRouting.model';
export * from './modulePage.model';
export * from './page.model';
export * from './rolePage.model';
export * from './areac.model';
export * from './structure.model';


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/index.ts